import SectionHead from "./SectionHead";
import { steps } from "@/mocks/homeData";

export default function HowItWorks() {
  return (
    <section id="how" className="bg-background-50 py-16 md:py-24" aria-label="投稿教程">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="投稿教程"
          title="三步完成发帖爆料"
          desc="从写出故事到登上热榜，整套流程简单清晰，吧友在线审核帮你把关，吃瓜投稿轻松上手。"
        />

        <ol className="grid gap-6 md:grid-cols-3">
          {steps.map((step) => (
            <li
              key={step.no}
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 p-6 transition-transform hover:-translate-y-1 md:p-7"
            >
              <span className="absolute right-4 top-4 font-serifsc text-6xl font-black text-background-200 group-hover:text-accent-300 md:text-7xl" aria-hidden="true">
                {step.no}
              </span>
              <span className="relative flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-white">
                <i className={`${step.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-serifsc relative mt-5 text-xl font-bold text-foreground-950">{step.title}</h3>
              <p className="relative mt-3 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              <span className="mt-auto flex items-center gap-2 pt-6 text-sm font-semibold text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                跟着做准没错 <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}